import { Navigate } from 'react-router-dom';
import { Button, Card, CardBody } from '@vnetwork/ui/primitives';
import { brand, brandCopyright } from '@/config/brand';
import { maintenanceEnabled, pickMessage, useMaintenance } from '@/api/maintenance';
import { formatDateTime } from '@/lib/format-date';
import styles from './AuthMessage.module.css';

/**
 * System-maintenance screen. The text and the expected end come from the maintenance window that
 * staff schedule through the API; the page re-checks every 15 s and sends people back to the login
 * as soon as the window is over.
 */
export default function MaintenancePage() {
  const { data, isPending, refetch, isFetching } = useMaintenance(15_000);

  // Nothing is scheduled (or the gate is off): there is nothing to wait for.
  if (!maintenanceEnabled || (!isPending && !data?.maintenance)) {
    return <Navigate to="/auth/login" replace />;
  }

  const active = data?.active;
  const text = pickMessage(active?.message);

  return (
    <div className={styles.screen}>
      <div className={styles.box}>
        <img src={brand.assets.icon} width={48} height={48} alt={brand.shortName} className={styles.logo} />
        <Card>
          <CardBody>
            <div className={styles.content}>
              <h1 className={styles.title}>System maintenance</h1>
              <p className={styles.text}>{text || 'We are performing scheduled maintenance.'}</p>
              {active && (
                <p className={styles.text}>Expected completion: {formatDateTime(active.ends_at)}</p>
              )}
              <p className={styles.muted}>Thank you for your patience.</p>
              <Button variant="secondary" onClick={() => void refetch()} disabled={isFetching}>
                Check again
              </Button>
            </div>
          </CardBody>
        </Card>
        <p className={styles.copyright}>{brandCopyright(2026)}</p>
      </div>
    </div>
  );
}
